function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "nohjd3ykla",
  width: "212.5%",
  height: "212.5%",
  x: "-56.2%",
  y: "-43.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0.784313725 0 0 0 0 0.325490196 0 0 0 0.7 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "gl0myb7fxb",
  cx: 12,
  cy: 12,
  r: 12
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H36V36H0z",
  transform: "translate(-1123.000000, -841.000000) translate(898.000000, 79.000000) translate(225.000000, 762.000000)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  opacity: 0.9,
  transform: "translate(-1123.000000, -841.000000) translate(898.000000, 79.000000) translate(225.000000, 762.000000) translate(6.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#nohjd3ykla)",
  xlinkHref: "#gl0myb7fxb"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#gl0myb7fxb"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#00C853",
  d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 6.25c-2.063 0-3.75 1.688-3.75 3.75 0 2.063 1.688 3.75 3.75 3.75 2.063 0 3.75-1.688 3.75-3.75 0-2.063-1.688-3.75-3.75-3.75z",
  transform: "translate(-1123.000000, -841.000000) translate(898.000000, 79.000000) translate(225.000000, 762.000000) translate(6.000000, 6.000000)"
}))))));
function SvgMapStarting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapStarting);
export default __webpack_public_path__ + "static/media/map-starting.cfb68f66aa87e6adc757a0d21e360e8e.svg";
export { ForwardRef as ReactComponent };